import React from "react";
import Styles from './styles.module.scss'

import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";

import img1 from '../../theme/assets/other/tc_future_s2_icon1.png';
import img2 from '../../theme/assets/other/tc_future_s2_icon2.png';
import img3 from '../../theme/assets/other/tc_future_s2_icon3.png';
import img4 from '../../theme/assets/other/tc_future_s2_icon4.png';
import img5 from '../../theme/assets/other/tc_future_s2_icon5.png';
import img6 from '../../theme/assets/other/tc_future_s2_icon6.png';



const FutureS2 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.title}`}>{t('Технологические особенности:')}</div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxM}`}>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img1} alt={t('Самодостаточная цифровая экосистема')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Самодостаточная цифровая экосистема')}</div>
                                <div className={`${Styles.text}`}>{t('Мир работает на основе децентрализованных протоколов, обеспечивая автономность, устойчивость и масштабируемость.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img2} alt={t('Цифровые личности как активные агенты')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Цифровые личности как активные агенты')}</div>
                                <div className={`${Styles.text}`}>{t('Каждая оцифрованная личность интегрируется в метавселенную с сохранением уникальных характеристик, поведенческих паттернов и индивидуального мышления.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img3} alt={t('ИИ для моделирования поведения')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('ИИ для моделирования поведения')}</div>
                                <div className={`${Styles.text}`}>{t('Алгоритмы анализируют личностные данные и воспроизводят характер, реакции и решения персонажей в реальном времени.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img4} alt={t('Интерактивные сценарии и социальная динамика')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Интерактивные сценарии и социальная динамика')}</div>
                                <div className={`${Styles.text}`}>{t('Персонажи могут взаимодействовать друг с другом, формировать сообщества, сотрудничать и влиять на развитие экосистемы.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img5} alt={t('Дефляционная экономика и токенизация')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Дефляционная экономика и токенизация')}</div>
                                <div className={`${Styles.text}`}>{t('Внутренняя система токенов поддерживает ценность цифровых личностей: токены расходуются на действия и взаимодействия, сгорают и стимулируют рост стоимости активов.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img6} alt={t('Безопасность и конфиденциальность')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Безопасность и конфиденциальность')}</div>
                                <div className={`${Styles.text}`}>{t('Все данные зашифрованы и защищены, цифровые личности управляются смарт-контрактами и остаются под контролем владельцев.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                </div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxD}`}>
                    <CustomBorder corners={{ topRight: true, bottomRight: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img1} alt={t('Самодостаточная цифровая экосистема')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Самодостаточная цифровая экосистема')}</div>
                                <div className={`${Styles.text}`}>{t('Мир работает на основе децентрализованных протоколов, обеспечивая автономность, устойчивость и масштабируемость.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topLeft: true, bottomLeft: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemR}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img2} alt={t('Цифровые личности как активные агенты')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Цифровые личности как активные агенты')}</div>
                                <div className={`${Styles.text}`}>{t('Каждая оцифрованная личность интегрируется в метавселенную с сохранением уникальных характеристик, поведенческих паттернов и индивидуального мышления.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topRight: true, bottomRight: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img3} alt={t('ИИ для моделирования поведения')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('ИИ для моделирования поведения')}</div>
                                <div className={`${Styles.text}`}>{t('Алгоритмы анализируют личностные данные и воспроизводят характер, реакции и решения персонажей в реальном времени.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topLeft: true, bottomLeft: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemR}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img4} alt={t('Интерактивные сценарии и социальная динамика')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Интерактивные сценарии и социальная динамика')}</div>
                                <div className={`${Styles.text}`}>{t('Персонажи могут взаимодействовать друг с другом, формировать сообщества, сотрудничать и влиять на развитие экосистемы.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topRight: true, bottomRight: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img5} alt={t('Дефляционная экономика и токенизация')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Дефляционная экономика и токенизация')}</div>
                                <div className={`${Styles.text}`}>{t('Внутренняя система токенов поддерживает ценность цифровых личностей: токены расходуются на действия и взаимодействия, сгорают и стимулируют рост стоимости активов.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topLeft: true, bottomLeft: true }} cutSize={15}>
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemR}`}>
                            <div className={`${Styles.contentBoxItemImgWrap}`}>
                                <img src={img6} alt={t('Безопасность и конфиденциальность')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTextWrap}`}>
                                <div className={`${Styles.textTitle}`}>{t('Безопасность и конфиденциальность')}</div>
                                <div className={`${Styles.text}`}>{t('Все данные зашифрованы и защищены, цифровые личности управляются смарт-контрактами и остаются под контролем владельцев.')}</div>
                            </div>
                        </div>
                    </CustomBorder>
                </div>
                <div className={`${Styles.note}`}><span>Future Meta Earth</span> — {t('это автономная метавселенная нового поколения, созданная для цифровых личностей Тайм Капсулы. Она сочетает передовые технологии виртуальной среды, искусственного интеллекта и блокчейна, формируя уникальное пространство для существования, взаимодействия и развития цифровых сущностей.')}</div>
                <div className={`${Styles.btnWrap}`}>
                    <CustomBorder corners={{ topRight: true, bottomLeft: true }} fill="#4b4954">
                        <button className={`${Styles.btn} ${Styles.cornerDsb}`}><div>{t('Исследовать метавселенную')}</div> <span>({t('Скоро')})</span></button>
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default FutureS2;